import { DataSelector } from '@atoms/dataSelectors/dataSelector/dataSelector';
import { InputField } from '@atoms/input';

import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';

import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialDropDownData } from './dropDown.data';
import { DropDownModal } from './dropDown.modal';
import { DropDownIcon } from './dropDown.utils';

const DropDown = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'Drop Down',
    sourceId: block.id,
    parentId: actionId,
    parentKind: 'form_action',
    initialData: initialDropDownData,
    variableInfo: {
      resolvedType: ResolvedVariableType.Text
    }
  });

  if (!atom) {
    return null;
  }

  const getSettingsModal = (): SettingsConfig => ({
    title: atom.data.title || 'Drop Down title',
    content: <DropDownModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getSettingsModal()}
    />
  );

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={DropDownIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Field title"
          onChange={e => (atom.data.title = e.target.value)}
          placeholder="Aa"
          required
          value={atom.data.title}
        />
      </Column>
      <DataSelector
        dataSource={atom.data.dataSource}
        id={atom.id}
        onDataSourceChange={v => (atom.data.dataSource = v)}
        onSourceDataChange={v => (atom.data.dataSourceData = v)}
        sourcesData={atom.data.dataSourceData}
      />
    </BlockBase>
  );
};

export default observer(DropDown);
